import { BASE_ROUTES, SETTINGS, SPORTS } from '../constants/routes'
import MenuItem from '../widgets/menu/menuItem'
import { getIcon } from './image'

export const menuUncollapsed = 'menuUncollapsed'
export const menuCollapsed = 'menuCollapsed'

const { HOME, SEARCH } = BASE_ROUTES

export const itemsMap = [
  {
    name: 'Search',
    route: SEARCH,
    itemMargin: {
      flexItem: {
        marginBottom: 12,
      },
    },
  },
  {
    name: 'Home',
    route: HOME,
    itemMargin: {
      flexItem: {
        marginBottom: 12,
      },
    },
  },
  {
    name: 'Sports',
    route: SPORTS,
    itemMargin: {
      flexItem: {
        marginBottom: 12,
      },
    },
  },
  {
    name: 'Settings',
    route: SETTINGS,
    itemMargin: {
      flexItem: {
        marginBottom: 12,
      },
    },
  },
]

export const createItems = () => {
  return itemsMap.map((item, index) => {
    return {
      type: MenuItem,
      itemText: item.name,
      itemIcon: getIcon(`icon-${item.name.toString().toLowerCase()}`),
      route: item.route,
      isSelected: item.route === HOME,
      itemIndex: index,
      totalItems: itemsMap.length,
      ...item.itemMargin,
    }
  })
}
